import { InstallationPredictedStatusEnum } from "./InstallationPredictedStatusEnum";
import { Prediction } from "./Prediction";
import { Installation } from "../Installation";

export class InstallationPredictedStatus extends Installation {
    predictedMachineStatus: Prediction[] = [];
    /** Stato della manutenzione calcolato sulla base dello stato di manutenzione delle singole macchine */
    predictedInstallationStatus: InstallationPredictedStatusEnum;
    isNewPrediction: boolean;
    firstPredictionDateTime: Map<string, Date>;

    constructor() {
        super();
    }

    public parse(obj: any) {
        super.parse(obj);
        if (obj.PredictedStatusMachines && Object.keys(obj.PredictedStatusMachines).length > 0) {
            Object.keys(obj.PredictedStatusMachines).forEach((key) => {
                let ms: Prediction = new Prediction();
                ms.parse(obj.PredictedStatusMachines[key]);
                this.predictedMachineStatus.push(ms);
            });
            this.predictedInstallationStatus = Math.max(...this.predictedMachineStatus.map((p) => p.status));
        } else this.predictedInstallationStatus = InstallationPredictedStatusEnum.Ok;

        if (obj.IsNewPrediction != null && obj.IsNewPrediction != undefined) this.isNewPrediction = obj.IsNewPrediction;
        if (obj.FirstPredictionDateTime) {
            this.firstPredictionDateTime = new Map<string, Date>();
            Object.keys(obj.FirstPredictionDateTime).forEach((key) => {
                this.firstPredictionDateTime.set(key, obj.FirstPredictionDateTime[key]);
            });
        }
    }
}
